import { Download } from "lucide-react";
import { useLang } from "../i18n";
import { CATALOGUE_LABEL } from "../i18n-products";

export const CatalogueButton = ({ variant = "link", testId = "download-catalogue", className = "" }) => {
  const { lang } = useLang();
  const label = CATALOGUE_LABEL[lang] || CATALOGUE_LABEL.en;
  if (variant === "light") {
    return (
      <a href="/sana-steel-catalogue.pdf" download data-testid={testId} className={`btn-light ${className}`}>
        <Download size={16} /> {label}
      </a>
    );
  }
  return (
    <a
      href="/sana-steel-catalogue.pdf"
      download
      data-testid={testId}
      className={`font-heading text-xs font-bold uppercase tracking-[0.2em] text-navy inline-flex items-center gap-2 hover:text-steel transition-colors duration-200 ${className}`}
    >
      <Download size={16} /> {label}
    </a>
  );
};
